import React from 'react'
import { useMultiSite } from 'msp-integrations'
import BaseCustomLinkComponent from './CustomLink'
import CustomLinkType from './CustomLink.types'

const CustomLink = (data: CustomLinkType) => {
  const { buildUrl } = useMultiSite()

  if (data && data.href) {
    if (data.href === '') {
      data.href = '#'
    }

    if (!data.isExternalLink && data.href !== '/') {
      data.href = buildUrl(data.href)
    }
  }

  return <BaseCustomLinkComponent data={data} />
}

const CustomLinkComponent = (props: CustomLinkType) => {
  const data = Object.assign({}, props.data || props || {})
  if (props.custom?.content?.href) {
    data.href = props.custom?.content?.href
  }
  return CustomLink(Object.assign({}, data))
}

export default CustomLinkComponent
